import BookkeepingList from "components/Picker/Bookkeeping/BookkeepingList";
import React, { useContext, useEffect } from "react";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import { getSortedBookkeepings, initialBookkeepingFilter } from "./FilterTypes/BookkeepingFilterType";
import MultiPickerFilterPopup from "./MultiPickerFilterPopup";

interface SingleBookkeepingFilterProps {
  initialBookkeeping: server.dto.BookkeepingSmall | null;
}

/*
 * This is a variation on the bookkeeping filter that allows only a single bookkeeping to be selected.
 * It is using the same filter as the multi bookkeeping filter, so the two cannot be used at the same time.
 */
const SingleBookkeepingFilter = (props: SingleBookkeepingFilterProps) => {
  const title = RESX.Bookkeeping.resxBookkeeping;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("bookkeepings", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getSortedBookkeepings(filter).join(", ")}</>,
    hasValue: (filter) => filter.selectedBookkeepings.length > 0,
    reset: () => initialBookkeepingFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedBookkeepings.map(b => b.bookkeepingId), b.selectedBookkeepings.map(b => b.bookkeepingId))
  });
  useEffect(() => {
    setInitialValue("bookkeepings", {
      selectedBookkeepings: props.initialBookkeeping ? [props.initialBookkeeping] : [],
    });
  }, []);

  const [selectedBookkeepings, setSelectedBookkeepings] = React.useState<server.dto.BookkeepingSmall[]>(initialBookkeepingFilter.selectedBookkeepings);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedBookkeepings(getValue("bookkeepings").selectedBookkeepings);
    setPopupOpen(true);
  };

  const onSelect = (bookkeeping: server.dto.BookkeepingSmall) => {
    setSelectedBookkeepings([bookkeeping]);
    setValue("bookkeepings", {
      selectedBookkeepings: [bookkeeping],
    });
    setPopupOpen(false);
  }

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("bookkeepings", {
      selectedBookkeepings,
    });
    setPopupOpen(false);
  };

  return <div>
    <MultiPickerFilterPopup
      title={title}
      minHeight={350}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
      onApply={onApply}
    >
      <BookkeepingList
        excludeKeys={selectedBookkeepings.map(b => b.bookkeepingId)}
        securityScope="limitByUserAccess"
        onItemSelected={onSelect}
      />
    </MultiPickerFilterPopup>
  </div>;
};

export default SingleBookkeepingFilter;
